import * as React from "react";
import styled from "styled-components";
import Card, { Props as CardProps } from "./Card";
import { useDrag } from "react-dnd";
import { getEmptyImage } from "react-dnd-html5-backend";

const StyledDraggableCard = styled.div<{
  isDraggable: boolean;
  opacity: number;
}>`
  cursor: ${({ isDraggable }) => (isDraggable ? `grab` : "not-allowed")};
  opacity: ${({ opacity }) => `${opacity}`};
`;

const DraggableCard: React.FC<
  CardProps & { onBegin: () => void; onEnd: () => void }
> = ({ onClick, onBegin, onEnd, enabled, selected, ...props }) => {
  const [{ opacity, isDragging }, drag, preview] = useDrag({
    item: { name: props.number, type: "card", enabled, props: { ...props } },
    canDrag: (monitor) => !!enabled,
    collect: (monitor) => ({
      opacity: monitor.isDragging() || selected ? 0 : 1,
      isDragging: monitor.isDragging(),
    }),
    begin: (monitor) => {
      onBegin && onBegin();
    },
    end: (item, monitor) => {
      onEnd && !monitor.didDrop() && onEnd();
    },
  });
  React.useEffect(() => {
    preview(getEmptyImage());
  }, [preview]);
  return (
    <StyledDraggableCard ref={drag} isDraggable={!!enabled} opacity={opacity}>
      <Card {...props} enabled={enabled} selected={isDragging}></Card>
    </StyledDraggableCard>
  );
};

export default DraggableCard;
